import { User, UserTenant, UserTenants } from "../types/User";

export function isAdmin(user: User | undefined): boolean {
  if (user !== undefined && user.tenants !== undefined) {
    const tenant: UserTenant | any = user.tenants.find(
      (tenent: UserTenants) => tenent.tenantId === user.activeTenantId,
    );
    if (tenant !== undefined) {
      return tenant.role === "admin";
    }
  }
  return false;
}
